import React, { ChangeEvent, useState } from 'react';
import {
  Button, Col, Input, Modal, Row,
} from 'antd';
import Styles from './TransferenceCalculatorComponent.module.scss';
import CalculatorFindImage from './images/calculator-find-image.webp';
import { TransferenceCalculatorComponentTypes } from './TransferenceCalculatorComponent.types';
import clConfig from '../../../helpers/countryHelper/configs/cl';
import { ArrowLeftOutlined, CloseCircleFilled } from '@ant-design/icons';

const TransferenceCalculatorComponent = ({
  className = 'default-container', children,
}: TransferenceCalculatorComponentTypes) => {
  const officialTariff = clConfig.body.arancelPrice;
  const transferServiceValue = '59.990';

  const [showResultView, setShowResultView] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [verifyInput, setVerifyInput] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>('');

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const formatInputValue = (value: string): string => {
    const formattedValue = value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `$${formattedValue}`;
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const rawValue = event.target.value;
    const formattedValue = formatInputValue(rawValue);
    setInputValue(formattedValue);
    setVerifyInput(false);
  };

  const handleSubmitPriceValue = () => {
    if (inputValue !== '' && inputValue !== '$ ') {
      setShowResultView(!showResultView);
    } else {
      setVerifyInput(true);
    }
  };

  const getTotalTrfPrice = (): number => officialTariff
    + parseInt(transferServiceValue.replace(/[^\d]/g, ''), 10)
    + Math.ceil(parseInt(inputValue.replace(/[^\d]/g, ''), 10) * 0.015);

  return (
    <>
      <Modal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className={Styles[`${className}-modal`]}
        title={(
          <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'flex-start' }}>
            <h2 style={{
              color: '#262626', fontSize: '16px', fontWeight: '700px', margin: '0px'
            }}
            >
              ¿Donde encontrar el precio de tasación?
            </h2>
            <CloseCircleFilled style={{ fontSize: '24px', color: '#6694DD' }} onClick={handleCancel} />
          </div>
        )}
        footer={[
          <Button key="back" onClick={handleCancel} type='default' size='large' style={{
            color: '#004CC6', padding: "8px 16px;", borderRadius: '12px',
            border: '1px solid var(--primarios-azul-primario-9, #1A5ECC)',
          }}>Cerrar</Button>,
        ]}
        closeIcon={null}
        styles={{ body: { overflow: 'hidden' } }}
      >
        <p>Puedes encontrar el valor de tasación en el permiso de circulación, la ubicación puede variar según la comuna.</p>
        <div className={Styles[`${className}-modal-img-container`]}>
          <img src={CalculatorFindImage} alt="Autofact" className={Styles[`${className}-modal-img`]} />
          <div className={Styles[`${className}-img-shadow`]} />
        </div>
      </Modal>
      {!showResultView && (
        <div className={Styles[className]}>
          {children}
          <Row>
            <Col xs={11} lg={13}>
              <strong className={Styles['description-text']}>Precio de venta o tasación fiscal (CLP)</strong>
            </Col>
            <Col xs={13} lg={11} style={{ justifyContent: 'end', display: 'flex', alignItems: 'end' }}>
              <button
                type="button"
                className={Styles['button-find-price']}
                onClick={() => showModal()}
              >
                Encontrar precio de tasación
              </button>
            </Col>
          </Row>
          <div className={Styles[`${className}-input`]}>
            <Input value={inputValue} onChange={handleChange} placeholder="Ej: $5.200.000" />
            {verifyInput && <p style={{ color: 'red', fontSize: '14px' }}>Ingrese un valor</p>}
            <Button
              type="primary"
              onClick={handleSubmitPriceValue}
              style={{
                borderRadius: "12px",
                background: "var(--primarios-azul-primario-10, #004CC6)"
              }}
            >
              Calcular valor total
            </Button>
          </div>
        </div>
      )}
      {showResultView && (
        <div className={`${Styles[`${className}-second-view`]}`}>
          <button
            className={Styles['align-items-center']}
            onClick={() => { setShowResultView(!showResultView); }}
            type="button"
          >
            {/* <AFIcon src="arrowLeftBlue" style={{ backgroundColor: 'white', verticalAlign: 'sub' }} height={20} width={20} /> */}
            <ArrowLeftOutlined style={{ fontSize: '24px', color: '#004CC6' }} />
            <strong style={{ color: '#262626', fontSize: '16px', lineHeight: '24px' }}>Volver a calcular</strong>
          </button>
          <div className={Styles[`${className}-second-view-content`]}>
            <div className={Styles['w-100']}>
              <h4>Incluye todos los impuestos y aranceles:</h4>
              <div className={Styles['inline-price']}>
                <span>Arancel Oficial:</span>
                <span className={Styles['bold-price-value']}>{formatInputValue(`${officialTariff}`)}</span>
              </div>
              <div className={Styles['inline-price']}>
                <span>Impuesto Transferencia Tesorería:</span>
                <span className={Styles['bold-price-value']}>
                  {formatInputValue(
                    (Math.ceil(((parseFloat(inputValue.replace(/[^\d]/g, ''))) * 0.015)))
                      .toString(),
                  )}
                </span>
              </div>
              <div className={Styles['inline-price']}>
                <span>Valor servicio transferencia:</span>
                <span className={Styles['bold-price-value']}>{formatInputValue(transferServiceValue)}</span>
              </div>
              <hr />
              <div className={Styles['inline-price']}>
                <span><strong className={Styles['total-price']}>Valor total de la transferencia:</strong></span>
                <span className={Styles['bold-price-value-total']}>{formatInputValue(getTotalTrfPrice().toString())}</span>
              </div>
              {/* <Button
                type="primary"
                className={Styles['yellow-button']}
                href="/transferencias#iniciar-transferencia"
              >
                Iniciar Transferencia
              </Button> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TransferenceCalculatorComponent;
